// Language configuration and utilities

export const LANGUAGES = {
  FI: 'fi',
  EN: 'en',
  SV: 'sv'
};

export const LANGUAGE_OPTIONS = [
  { text: "Suomeksi", lang: LANGUAGES.FI },
  { text: "På svenska", lang: LANGUAGES.SV },
  { text: "In English", lang: LANGUAGES.EN }
];

export const DEFAULT_LANGUAGE = LANGUAGES.FI;

/**
 * Get language from URL parameters
 * @param {URLSearchParams} urlParams - URL search parameters
 * @returns {string} Language code (fi, en, sv)
 */
export const getLanguageFromURL = (urlParams) => {
  const langParam = urlParams.get("lang");

  if (langParam === LANGUAGES.EN) return LANGUAGES.EN;
  if (langParam === LANGUAGES.SV) return LANGUAGES.SV;
  if (langParam === LANGUAGES.FI) return LANGUAGES.FI;

  return DEFAULT_LANGUAGE;
};

/**
 * Set HTML document language attribute
 * @param {string} language - Language code (fi, en, sv)
 */
export const setDocumentLanguage = (language) => {
  document.documentElement.lang = language;
};

/**
 * Get language index for array-based lookups
 * @param {string} language - Language code (fi, en, sv)
 * @returns {number} Index (0 for fi, 1 for sv, 2 for en)
 */
export const getLanguageIndex = (language) => {
  switch (language) {
    case LANGUAGES.EN:
      return 2;
    case LANGUAGES.SV:
      return 1;
    case LANGUAGES.FI:
    default:
      return 0;
  }
};
